import httpClient from "../httpClient"

import { formatData } from "../request"
import { encodeRequestParameters } from "../request"

import { moniboxFormat } from "../formats"

export async function createMonibox(payload) {
    payload = formatData(moniboxFormat, payload)

    if (!payload) {
        throw "500"
    }

    return await httpClient
        .post("/monibox", payload)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function getMonibox(id) {
    return httpClient
        .get(`/monibox/${id}`)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function updateMonibox(id, payload) {
    payload = formatData(moniboxFormat, payload)

    if (!payload) {
        throw "500"
    }

    return await httpClient
        .post(`/monibox/${id}`, payload)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function deleteMonibox(id) {
    return await httpClient
        .delete(`/monibox/${id}`)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function getLifeCycle(id, params = {}) {
    params = encodeRequestParameters(params)

    return httpClient
        .get(`/monibox/${id}/status`, { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}
